// Copyright (c) 2017 Comsearch, Inc., All rights reserved

import React from 'react'
import { bool, func, string } from 'prop-types'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { push } from 'react-router-redux'

const CreateButton = ({ buttonClasses, databaseUser, dbSet, idRoot, push }) => {
  // non-db users cannot create new entities
  // and
  // no one can create a new path through the database management subtree.
  // in the UI, sall paths must be created through a project.
  if (!databaseUser || dbSet === 'path') {
    return null
  }

  const goToCreate = () => push(`/database-management/${dbSet}/new-${dbSet}`)

  return (
    <a
      id={`${idRoot}create`}
      className={`${buttonClasses} create-button bg-blue`}
      onClick={goToCreate}>
      {'Create'}
    </a>
  )
}

CreateButton.propTypes = {
  buttonClasses: string.isRequired,
  databaseUser: bool.isRequired,
  dbSet: string.isRequired,
  idRoot: string.isRequired,
  push: func.isRequired,
}

const mapStateToProps = ({ user }) => ({
  databaseUser: user.getIn(['permissions', 'database']),
})

const mapDispatchToProps = dispatch => (
  bindActionCreators({
    push,
  }, dispatch)
)

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(CreateButton)
